import { render, staticRenderFns } from "./MovementItemList.vue?vue&type=template&id=2aadb014"
import script from "./MovementItemList.vue?vue&type=script&lang=js"
export * from "./MovementItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports